import styled from "styled-components";

export function TabsSwitch({
  list,
  active,
  setActive,
}: {
  list: { label: string; key: string }[];
  active?: string;
  setActive?: (key: any) => void;
}) {
  return (
    <TabsSwitchWrapper>
      {list.map((i) => {
        return (
          <Button
            className={active === i.key ? "active" : ""}
            onClick={() => setActive?.(i.key)}
          >
            <span>{i.label}</span>
          </Button>
        );
      })}
    </TabsSwitchWrapper>
  );
}

const TabsSwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 32px;
  padding: 4px;
  font-size: 12px;
  background: #333336;
  border-radius: 2px;
  margin-bottom: 16px;
`;

const Button = styled.div`
  padding: 3px 12px;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s;
  color: rgba(255, 255, 255, 0.66);
  &.active {
    color: var(--main-color);
    background-color: #414144;
  }
`;
